// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"23a44f0d","239":"ba38921c","455":"fa4c2869"}[chunkId] + ".chunk.js";
};